<script>
  import {getContext, onMount} from 'svelte';
  import {timeUtil} from '@/helper/time';
  import {isIpPreRestricted$, isIpRestricted$, ipRestrictedConfig$, subPreRestrictedDialog} from './streams';
  import lang from './IpRestricted.lang';
  import {ipPromptHeight$} from '@/modules/header/stream';

  const LG = getContext('LG');
  const Email = '<a href="mailto:support@phemex.zendesk.com">support@phemex.zendesk.com</a>';

  let Date = '';
  let offsetHeight = 0;

  $: Date = timeUtil.formatUTCDate($ipRestrictedConfig$ && $ipRestrictedConfig$.startTime);
  $: ipPromptHeight$.next(offsetHeight);

  onMount(() => {
    subPreRestrictedDialog(LG);
  });
</script>

<style>
  .placeholder-block {
    width: 100%;
    height: 80px;
  }
  @media screen and (max-width: 640px) {
    .placeholder-block {
      height: 178px;
    }
  }
  .ip-restricted-notify {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    box-sizing: border-box;
    padding: 18px 36px;
    width: 100%;
    line-height: 44px;
    background: #fff;
  }
  .error {
    color: #ed0000;
  }
</style>

{#if $isIpPreRestricted$ || $isIpRestricted$}
  <div bind:offsetHeight>
    <div class="placeholder-block" />
    <div class="ip-restricted-notify df aic">
      <i class="iconfont error f16 mr10">&#xe6c3;</i>
      <div class="f14 lh22">{@html $isIpPreRestricted$ ? LG(lang.preRestrictedMsg, {Email, Date}) : LG(lang.restrictedMsg, {Email})}</div>
    </div>
  </div>
{/if}
